// OrderItem.js
import React from "react";
import { useTranslate } from "react-admin";
// MUI components
import { Box, Grid } from "@material-ui/core";
import CheckCircleOutlinedIcon from "@material-ui/icons/CheckCircleOutlined";
// // Local components
import { PortTooltip } from "./PortTooltipComponents/PortTooltip";
import { PortState } from "entities/PortDashboardState";
// Styled components / styles
import { ModernPortCircle, CleanPortLabel } from "./styles";

export const PortItem = ({ port, color, minutes, isUpdating, port_taken_duration }) => {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const translate = useTranslate();
	const handleMouseEnter = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleMouseLeave = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);

	return (
		<Grid
			item
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				width: "62px",
				height: "50px",
			}}
		>
			<Box
				display="flex"
				flexDirection="column"
				alignItems="center"
				width={"100%"}
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
				style={{
					cursor: "pointer",
				}}
			>
				<ModernPortCircle bgcolor={color} isUpdating={isUpdating} isHovered={anchorEl !== null}>
					<Box textAlign="center">
						{port.state === PortState.FREE ? (
							minutes !== null && minutes !== "N/A" ? (
								<>
									<div style={{ fontSize: "13px", fontWeight: "800", lineHeight: "1" }}>
										{minutes}
									</div>
									<div
										style={{ fontSize: "8px", fontWeight: "600", opacity: 0.95, marginTop: "1px" }}
									>
										{translate("resources.dashboard_ports.min")}
									</div>
								</>
							) : (
								<CheckCircleOutlinedIcon />
							)
						) : port.state === PortState.BUSY ? (
							<>
									<div style={{ fontSize: "13px", fontWeight: "800", lineHeight: "1" }}>
										{port_taken_duration}
									</div>
									<div
										style={{ fontSize: "8px", fontWeight: "600", opacity: 0.95, marginTop: "1px" }}
									>
										{translate("resources.dashboard_ports.min")}
									</div>
								</>
						) : (
							<div style={{ fontSize: "12px", fontWeight: "700" }}>N/A</div>
						)}
					</Box>
				</ModernPortCircle>
				<CleanPortLabel variant="caption" noWrap>
					{port.name}
				</CleanPortLabel>
			</Box>

			<PortTooltip
				open={open}
				anchorEl={anchorEl}
				port={port}
				color={color}
				minutes={minutes}
				port_taken_duration={port_taken_duration}
				onMouseEnter={() => setAnchorEl(anchorEl)}
				onMouseLeave={handleMouseLeave}
				translate={translate}
			/>
		</Grid>
	);
};
